/* shop/components/Order.svelte generated by Svelte v3.59.2 */
import {
	SvelteComponentDev,
	add_location,
	append_dev,
	attr_dev,
	check_outros,
	component_subscribe,
	create_component,
	destroy_component,
	destroy_each,
	detach_dev,
	dispatch_dev,
	element,
	empty,
	group_outros,
	init,
	insert_dev,
	listen_dev,
	mount_component,
	prop_dev,
	run_all,
	safe_not_equal,
	set_data_dev,
	space,
	text,
	transition_in,
	transition_out,
	validate_each_argument,
	validate_slots,
	validate_store
} from "svelte/internal";

import OrderPersonal from "./OrderPersonal.svelte";
import OrderCompany from "./OrderCompany.svelte";
import StandardDelivery from "./delivery/StandardDelivery.svelte";
import ZasilkovnaDelivery from "./delivery/ZasilkovnaDelivery.svelte";
import orderStore, { isDeliveryAvailableForPersonalPickup } from "./../orderStore";
const file = "shop/components/Order.svelte";

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[9] = list[i];
	return child_ctx;
}

function get_each_context_1(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[12] = list[i];
	return child_ctx;
}

// (28:4) {#if $orderStore.customer_type == 'PERSONAL'}
function create_if_block_4(ctx) {
	let orderpersonal;
	let current;
	orderpersonal = new OrderPersonal({ $$inline: true });

	const block = {
		c: function create() {
			create_component(orderpersonal.$$.fragment);
		},
		m: function mount(target, anchor) {
			mount_component(orderpersonal, target, anchor);
			current = true;
		},
		i: function intro(local) {
			if (current) return;
			transition_in(orderpersonal.$$.fragment, local);
			current = true;
		},
		o: function outro(local) {
			transition_out(orderpersonal.$$.fragment, local);
			current = false;
		},
		d: function destroy(detaching) {
			destroy_component(orderpersonal, detaching);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_if_block_4.name,
		type: "if",
		source: "(28:4) {#if $orderStore.customer_type == 'PERSONAL'}",
		ctx
	});

	return block;
}

// (32:4) {#if $orderStore.customer_type == 'COMPANY'}
function create_if_block_3(ctx) {
	let ordercompany;
	let current;
	ordercompany = new OrderCompany({ $$inline: true });

	const block = {
		c: function create() {
			create_component(ordercompany.$$.fragment);
		},
		m: function mount(target, anchor) {
			mount_component(ordercompany, target, anchor);
			current = true;
		},
		i: function intro(local) {
			if (current) return;
			transition_in(ordercompany.$$.fragment, local);
			current = true;
		},
		o: function outro(local) {
			transition_out(ordercompany.$$.fragment, local);
			current = false;
		},
		d: function destroy(detaching) {
			destroy_component(ordercompany, detaching);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_if_block_3.name,
		type: "if",
		source: "(32:4) {#if $orderStore.customer_type == 'COMPANY'}",
		ctx
	});

	return block;
}

// (68:57) 
function create_if_block_2(ctx) {
	let zasilkovnadelivery;
	let current;

	zasilkovnadelivery = new ZasilkovnaDelivery({
			props: { deliveryItem: /*deliveryItem*/ ctx[12] },
			$$inline: true
		});

	const block = {
		c: function create() {
			create_component(zasilkovnadelivery.$$.fragment);
		},
		m: function mount(target, anchor) {
			mount_component(zasilkovnadelivery, target, anchor);
			current = true;
		},
		p: function update(ctx, dirty) {
			const zasilkovnadelivery_changes = {};
			if (dirty & /*delivery*/ 1) zasilkovnadelivery_changes.deliveryItem = /*deliveryItem*/ ctx[12];
			zasilkovnadelivery.$set(zasilkovnadelivery_changes);
		},
		i: function intro(local) {
			if (current) return;
			transition_in(zasilkovnadelivery.$$.fragment, local);
			current = true;
		},
		o: function outro(local) {
			transition_out(zasilkovnadelivery.$$.fragment, local);
			current = false;
		},
		d: function destroy(detaching) {
			destroy_component(zasilkovnadelivery, detaching);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_if_block_2.name,
		type: "if",
		source: "(68:57) ",
		ctx
	});

	return block;
}

// (66:8) {#if deliveryItem.type_slug == "standard" || deliveryItem.type_slug == "personal_pickup"}
function create_if_block_1(ctx) {
	let standarddelivery;
	let current;

	standarddelivery = new StandardDelivery({
			props: { deliveryItem: /*deliveryItem*/ ctx[12] },
			$$inline: true
		});

	const block = {
		c: function create() {
			create_component(standarddelivery.$$.fragment);
		},
		m: function mount(target, anchor) {
			mount_component(standarddelivery, target, anchor);
			current = true;
		},
		p: function update(ctx, dirty) {
			const standarddelivery_changes = {};
			if (dirty & /*delivery*/ 1) standarddelivery_changes.deliveryItem = /*deliveryItem*/ ctx[12];
			standarddelivery.$set(standarddelivery_changes);
		},
		i: function intro(local) {
			if (current) return;
			transition_in(standarddelivery.$$.fragment, local);
			current = true;
		},
		o: function outro(local) {
			transition_out(standarddelivery.$$.fragment, local);
			current = false;
		},
		d: function destroy(detaching) {
			destroy_component(standarddelivery, detaching);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_if_block_1.name,
		type: "if",
		source: "(66:8) {#if deliveryItem.type_slug == \\\"standard\\\" || deliveryItem.type_slug == \\\"personal_pickup\\\"}",
		ctx
	});

	return block;
}

// (65:4) {#each delivery as deliveryItem}
function create_each_block_1(ctx) {
	let current_block_type_index;
	let if_block;
	let if_block_anchor;
	let current;
	const if_block_creators = [create_if_block_1, create_if_block_2];
	const if_blocks = [];

	function select_block_type(ctx, dirty) {
		if (/*deliveryItem*/ ctx[12].type_slug == "standard" || /*deliveryItem*/ ctx[12].type_slug == "personal_pickup") return 0;
		if (/*deliveryItem*/ ctx[12].type_slug == "zasilkovna") return 1;
		return -1;
	}

	if (~(current_block_type_index = select_block_type(ctx, -1))) {
		if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
	}

	const block = {
		c: function create() {
			if (if_block) if_block.c();
			if_block_anchor = empty();
		},
		m: function mount(target, anchor) {
			if (~current_block_type_index) {
				if_blocks[current_block_type_index].m(target, anchor);
			}

			insert_dev(target, if_block_anchor, anchor);
			current = true;
		},
		p: function update(ctx, dirty) {
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if (~current_block_type_index) {
					if_blocks[current_block_type_index].p(ctx, dirty);
				}
			} else {
				if (if_block) {
					group_outros();

					transition_out(if_blocks[previous_block_index], 1, 1, () => {
						if_blocks[previous_block_index] = null;
					});

					check_outros();
				}

				if (~current_block_type_index) {
					if_block = if_blocks[current_block_type_index];

					if (!if_block) {
						if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
						if_block.c();
					} else {
						if_block.p(ctx, dirty);
					}

					transition_in(if_block, 1);
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				} else {
					if_block = null;
				}
			}
		},
		i: function intro(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o: function outro(local) {
			transition_out(if_block);
			current = false;
		},
		d: function destroy(detaching) {
			if (~current_block_type_index) {
				if_blocks[current_block_type_index].d(detaching);
			}

			if (detaching) detach_dev(if_block_anchor);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_each_block_1.name,
		type: "each",
		source: "(65:4) {#each delivery as deliveryItem}",
		ctx
	});

	return block;
}

// (94:12) {#if paymentMethod.price}
function create_if_block(ctx) {
	let t0;
	let t1_value = /*paymentMethod*/ ctx[9].price + "";
	let t1;
	let t2;

	const block = {
		c: function create() {
			t0 = text(": ");
			t1 = text(t1_value);
			t2 = text(" Kč");
		},
		m: function mount(target, anchor) {
			insert_dev(target, t0, anchor);
			insert_dev(target, t1, anchor);
			insert_dev(target, t2, anchor);
		},
		p: function update(ctx, dirty) {
			if (dirty & /*paymentMethods*/ 2 && t1_value !== (t1_value = /*paymentMethod*/ ctx[9].price + "")) set_data_dev(t1, t1_value);
		},
		d: function destroy(detaching) {
			if (detaching) detach_dev(t0);
			if (detaching) detach_dev(t1);
			if (detaching) detach_dev(t2);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_if_block.name,
		type: "if",
		source: "(94:12) {#if paymentMethod.price}",
		ctx
	});

	return block;
}

// (79:4) {#each paymentMethods as paymentMethod}
function create_each_block(ctx) {
	let input;
	let input_id_value;
	let input_checked_value;
	let input_disabled_value;
	let t0;
	let label;
	let t1_value = /*paymentMethod*/ ctx[9].title + "";
	let t1;
	let t2;
	let t3;
	let label_for_value;
	let mounted;
	let dispose;

	function click_handler_2() {
		return /*click_handler_2*/ ctx[6](/*paymentMethod*/ ctx[9]);
	}

	let if_block = /*paymentMethod*/ ctx[9].price && create_if_block(ctx);

	const block = {
		c: function create() {
			input = element("input");
			t0 = space();
			label = element("label");
			t1 = text(t1_value);
			t2 = space();
			if (if_block) if_block.c();
			t3 = space();
			attr_dev(input, "type", "radio");
			attr_dev(input, "class", "radok");
			attr_dev(input, "id", input_id_value = "payment_method_" + /*paymentMethod*/ ctx[9].id);
			input.checked = input_checked_value = /*$orderStore*/ ctx[2].payment_title == /*paymentMethod*/ ctx[9].title;
			input.disabled = input_disabled_value = /*paymentMethod*/ ctx[9].type == 'PERSONAL_PICKUP' && !/*$isDeliveryAvailableForPersonalPickup*/ ctx[3];
			add_location(input, file, 79, 8, 2178);
			attr_dev(label, "for", label_for_value = "payment_method_" + /*paymentMethod*/ ctx[9].id);
			add_location(label, file, 91, 8, 2715);
		},
		m: function mount(target, anchor) {
			insert_dev(target, input, anchor);
			insert_dev(target, t0, anchor);
			insert_dev(target, label, anchor);
			append_dev(label, t1);
			append_dev(label, t2);
			if (if_block) if_block.m(label, null);
			append_dev(label, t3);

			if (!mounted) {
				dispose = listen_dev(input, "click", click_handler_2, false, false, false, false);
				mounted = true;
			}
		},
		p: function update(new_ctx, dirty) {
			ctx = new_ctx;

			if (dirty & /*paymentMethods*/ 2 && input_id_value !== (input_id_value = "payment_method_" + /*paymentMethod*/ ctx[9].id)) {
				attr_dev(input, "id", input_id_value);
			}

			if (dirty & /*$orderStore, paymentMethods*/ 6 && input_checked_value !== (input_checked_value = /*$orderStore*/ ctx[2].payment_title == /*paymentMethod*/ ctx[9].title)) {
				prop_dev(input, "checked", input_checked_value);
			}

			if (dirty & /*paymentMethods, $isDeliveryAvailableForPersonalPickup*/ 10 && input_disabled_value !== (input_disabled_value = /*paymentMethod*/ ctx[9].type == 'PERSONAL_PICKUP' && !/*$isDeliveryAvailableForPersonalPickup*/ ctx[3])) {
				prop_dev(input, "disabled", input_disabled_value);
			}

			if (dirty & /*paymentMethods*/ 2 && t1_value !== (t1_value = /*paymentMethod*/ ctx[9].title + "")) set_data_dev(t1, t1_value);

			if (/*paymentMethod*/ ctx[9].price) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					if_block.m(label, t3);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}

			if (dirty & /*paymentMethods*/ 2 && label_for_value !== (label_for_value = "payment_method_" + /*paymentMethod*/ ctx[9].id)) {
				attr_dev(label, "for", label_for_value);
			}
		},
		d: function destroy(detaching) {
			if (detaching) detach_dev(input);
			if (detaching) detach_dev(t0);
			if (detaching) detach_dev(label);
			if (if_block) if_block.d();
			mounted = false;
			dispose();
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_each_block.name,
		type: "each",
		source: "(79:4) {#each paymentMethods as paymentMethod}",
		ctx
	});

	return block;
}

function create_fragment(ctx) {
	let h1;
	let t1;
	let div0;
	let t3;
	let div2;
	let section0;
	let t4;
	let t5;
	let div1;
	let section1;
	let h20;
	let t7;
	let input0;
	let input0_checked_value;
	let t8;
	let label0;
	let t10;
	let input1;
	let input1_checked_value;
	let t11;
	let label1;
	let t13;
	let section2;
	let h21;
	let t15;
	let t16;
	let section3;
	let h22;
	let t18;
	let t19;
	let div3;
	let input2;
	let input2_checked_value;
	let t20;
	let label2;
	let t21;
	let a;
	let t23;
	let div4;
	let input3;
	let input3_checked_value;
	let t24;
	let label3;
	let current;
	let mounted;
	let dispose;
	let if_block0 = /*$orderStore*/ ctx[2].customer_type == 'PERSONAL' && create_if_block_4(ctx);
	let if_block1 = /*$orderStore*/ ctx[2].customer_type == 'COMPANY' && create_if_block_3(ctx);
	let each_value_1 = /*delivery*/ ctx[0];
	validate_each_argument(each_value_1);
	let each_blocks_1 = [];

	for (let i = 0; i < each_value_1.length; i += 1) {
		each_blocks_1[i] = create_each_block_1(get_each_context_1(ctx, each_value_1, i));
	}

	const out = i => transition_out(each_blocks_1[i], 1, 1, () => {
		each_blocks_1[i] = null;
	});

	let each_value = /*paymentMethods*/ ctx[1];
	validate_each_argument(each_value);
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	const block = {
		c: function create() {
			h1 = element("h1");
			h1.textContent = "Objednávka";
			t1 = space();
			div0 = element("div");
			div0.textContent = " ";
			t3 = space();
			div2 = element("div");
			section0 = element("section");
			if (if_block0) if_block0.c();
			t4 = space();
			if (if_block1) if_block1.c();
			t5 = space();
			div1 = element("div");
			section1 = element("section");
			h20 = element("h2");
			h20.textContent = "Subjekt";
			t7 = space();
			input0 = element("input");
			t8 = space();
			label0 = element("label");
			label0.textContent = "Soukromá osoba";
			t10 = space();
			input1 = element("input");
			t11 = space();
			label1 = element("label");
			label1.textContent = "Firma";
			t13 = space();
			section2 = element("section");
			h21 = element("h2");
			h21.textContent = "Doprava";
			t15 = space();

			for (let i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].c();
			}

			t16 = space();
			section3 = element("section");
			h22 = element("h2");
			h22.textContent = "Platba";
			t18 = space();

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			t19 = space();
			div3 = element("div");
			input2 = element("input");
			t20 = space();
			label2 = element("label");
			t21 = text("Souhlasím se ");
			a = element("a");
			a.textContent = "všeobecnými obchodními podmínkami a zpracováním osobních údajů";
			t23 = space();
			div4 = element("div");
			input3 = element("input");
			t24 = space();
			label3 = element("label");
			label3.textContent = "Souhlasím s uložením svých kontaktních údajů do databáze KHER pro účely občasného informování o novinkách";
			add_location(h1, file, 22, 0, 552);
			attr_dev(div0, "class", "basketInfoEmpty");
			add_location(div0, file, 23, 0, 572);
			attr_dev(section0, "class", "basketOrderPerson");
			add_location(section0, file, 26, 0, 684);
			add_location(h20, file, 40, 4, 1020);
			attr_dev(input0, "type", "radio");
			attr_dev(input0, "class", "radok");
			attr_dev(input0, "id", "customer_type_personal");
			input0.checked = input0_checked_value = /*$orderStore*/ ctx[2].customer_type == 'PERSONAL';
			add_location(input0, file, 42, 4, 1042);
			attr_dev(label0, "for", "customer_type_personal");
			add_location(label0, file, 48, 4, 1266);
			attr_dev(input1, "type", "radio");
			attr_dev(input1, "class", "radok");
			attr_dev(input1, "id", "customer_type_company");
			input1.checked = input1_checked_value = /*$orderStore*/ ctx[2].customer_type == 'COMPANY';
			add_location(input1, file, 50, 4, 1330);
			attr_dev(label1, "for", "customer_type_company");
			add_location(label1, file, 56, 4, 1551);
			add_location(section1, file, 39, 0, 1006);
			add_location(h21, file, 62, 4, 1674);
			add_location(section2, file, 61, 0, 1660);
			add_location(h22, file, 76, 4, 2109);
			add_location(section3, file, 75, 0, 2095);
			attr_dev(div1, "class", "basketOrderPayment");
			add_location(div1, file, 37, 0, 948);
			attr_dev(div2, "class", "basketOrder");
			add_location(div2, file, 24, 0, 614);
			attr_dev(input2, "type", "checkbox");
			attr_dev(input2, "class", "checkok");
			attr_dev(input2, "id", "terms_and_conditions_consent");
			input2.required = true;
			input2.checked = input2_checked_value = /*$orderStore*/ ctx[2].terms_and_conditions_consent;
			input2.value = "true";
			add_location(input2, file, 103, 4, 3008);
			attr_dev(a, "href", "/obchodni-podminky/");
			attr_dev(a, "target", "_blank");
			add_location(a, file, 113, 59, 3382);
			attr_dev(label2, "for", "terms_and_conditions_consent");
			add_location(label2, file, 113, 4, 3327);
			attr_dev(div3, "class", "basketButtonWrap");
			add_location(div3, file, 102, 0, 2973);
			attr_dev(input3, "type", "checkbox");
			attr_dev(input3, "class", "checkok");
			attr_dev(input3, "id", "sending_newsletters_consent");
			input3.checked = input3_checked_value = /*$orderStore*/ ctx[2].sending_newsletters_consent;
			input3.value = "true";
			add_location(input3, file, 117, 4, 3546);
			attr_dev(label3, "for", "sending_newsletters_consent");
			add_location(label3, file, 126, 4, 3845);
			attr_dev(div4, "class", "basketButtonWrap");
			add_location(div4, file, 116, 0, 3511);
		},
		l: function claim(nodes) {
			throw new Error("options.hydrate only works if the component was compiled with the `hydratable: true` option");
		},
		m: function mount(target, anchor) {
			insert_dev(target, h1, anchor);
			insert_dev(target, t1, anchor);
			insert_dev(target, div0, anchor);
			insert_dev(target, t3, anchor);
			insert_dev(target, div2, anchor);
			append_dev(div2, section0);
			if (if_block0) if_block0.m(section0, null);
			append_dev(section0, t4);
			if (if_block1) if_block1.m(section0, null);
			append_dev(div2, t5);
			append_dev(div2, div1);
			append_dev(div1, section1);
			append_dev(section1, h20);
			append_dev(section1, t7);
			append_dev(section1, input0);
			append_dev(section1, t8);
			append_dev(section1, label0);
			append_dev(section1, t10);
			append_dev(section1, input1);
			append_dev(section1, t11);
			append_dev(section1, label1);
			append_dev(div1, t13);
			append_dev(div1, section2);
			append_dev(section2, h21);
			append_dev(section2, t15);

			for (let i = 0; i < each_blocks_1.length; i += 1) {
				if (each_blocks_1[i]) {
					each_blocks_1[i].m(section2, null);
				}
			}

			append_dev(div1, t16);
			append_dev(div1, section3);
			append_dev(section3, h22);
			append_dev(section3, t18);

			for (let i = 0; i < each_blocks.length; i += 1) {
				if (each_blocks[i]) {
					each_blocks[i].m(section3, null);
				}
			}

			insert_dev(target, t19, anchor);
			insert_dev(target, div3, anchor);
			append_dev(div3, input2);
			append_dev(div3, t20);
			append_dev(div3, label2);
			append_dev(label2, t21);
			append_dev(label2, a);
			insert_dev(target, t23, anchor);
			insert_dev(target, div4, anchor);
			append_dev(div4, input3);
			append_dev(div4, t24);
			append_dev(div4, label3);
			current = true;

			if (!mounted) {
				dispose = [
					listen_dev(input0, "click", /*click_handler*/ ctx[4], false, false, false, false),
					listen_dev(input1, "click", /*click_handler_1*/ ctx[5], false, false, false, false),
					listen_dev(input2, "change", /*change_handler*/ ctx[7], false, false, false, false),
					listen_dev(input3, "change", /*change_handler_1*/ ctx[8], false, false, false, false)
				];

				mounted = true;
			}
		},
		p: function update(ctx, [dirty]) {
			if (/*$orderStore*/ ctx[2].customer_type == 'PERSONAL') {
				if (if_block0) {
					if (dirty & /*$orderStore*/ 4) {
						transition_in(if_block0, 1);
					}
				} else {
					if_block0 = create_if_block_4(ctx);
					if_block0.c();
					transition_in(if_block0, 1);
					if_block0.m(section0, t4);
				}
			} else if (if_block0) {
				group_outros();

				transition_out(if_block0, 1, 1, () => {
					if_block0 = null;
				});

				check_outros();
			}

			if (/*$orderStore*/ ctx[2].customer_type == 'COMPANY') {
				if (if_block1) {
					if (dirty & /*$orderStore*/ 4) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_3(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(section0, null);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}

			if (!current || dirty & /*$orderStore*/ 4 && input0_checked_value !== (input0_checked_value = /*$orderStore*/ ctx[2].customer_type == 'PERSONAL')) {
				prop_dev(input0, "checked", input0_checked_value);
			}

			if (!current || dirty & /*$orderStore*/ 4 && input1_checked_value !== (input1_checked_value = /*$orderStore*/ ctx[2].customer_type == 'COMPANY')) {
				prop_dev(input1, "checked", input1_checked_value);
			}

			if (dirty & /*delivery*/ 1) {
				each_value_1 = /*delivery*/ ctx[0];
				validate_each_argument(each_value_1);
				let i;

				for (i = 0; i < each_value_1.length; i += 1) {
					const child_ctx = get_each_context_1(ctx, each_value_1, i);

					if (each_blocks_1[i]) {
						each_blocks_1[i].p(child_ctx, dirty);
						transition_in(each_blocks_1[i], 1);
					} else {
						each_blocks_1[i] = create_each_block_1(child_ctx);
						each_blocks_1[i].c();
						transition_in(each_blocks_1[i], 1);
						each_blocks_1[i].m(section2, null);
					}
				}

				group_outros();

				for (i = each_value_1.length; i < each_blocks_1.length; i += 1) {
					out(i);
				}

				check_outros();
			}

			if (dirty & /*paymentMethods, $orderStore, $isDeliveryAvailableForPersonalPickup, orderStore*/ 14) {
				each_value = /*paymentMethods*/ ctx[1];
				validate_each_argument(each_value);
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(section3, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value.length;
			}

			if (!current || dirty & /*$orderStore*/ 4 && input2_checked_value !== (input2_checked_value = /*$orderStore*/ ctx[2].terms_and_conditions_consent)) {
				prop_dev(input2, "checked", input2_checked_value);
			}

			if (!current || dirty & /*$orderStore*/ 4 && input3_checked_value !== (input3_checked_value = /*$orderStore*/ ctx[2].sending_newsletters_consent)) {
				prop_dev(input3, "checked", input3_checked_value);
			}
		},
		i: function intro(local) {
			if (current) return;
			transition_in(if_block0);
			transition_in(if_block1);

			for (let i = 0; i < each_value_1.length; i += 1) {
				transition_in(each_blocks_1[i]);
			}

			current = true;
		},
		o: function outro(local) {
			transition_out(if_block0);
			transition_out(if_block1);
			each_blocks_1 = each_blocks_1.filter(Boolean);

			for (let i = 0; i < each_blocks_1.length; i += 1) {
				transition_out(each_blocks_1[i]);
			}

			current = false;
		},
		d: function destroy(detaching) {
			if (detaching) detach_dev(h1);
			if (detaching) detach_dev(t1);
			if (detaching) detach_dev(div0);
			if (detaching) detach_dev(t3);
			if (detaching) detach_dev(div2);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();
			destroy_each(each_blocks_1, detaching);
			destroy_each(each_blocks, detaching);
			if (detaching) detach_dev(t19);
			if (detaching) detach_dev(div3);
			if (detaching) detach_dev(t23);
			if (detaching) detach_dev(div4);
			mounted = false;
			run_all(dispose);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_fragment.name,
		type: "component",
		source: "",
		ctx
	});

	return block;
}

function instance($$self, $$props, $$invalidate) {
	let $orderStore;
	let $isDeliveryAvailableForPersonalPickup;
	validate_store(orderStore, 'orderStore');
	component_subscribe($$self, orderStore, $$value => $$invalidate(2, $orderStore = $$value));
	validate_store(isDeliveryAvailableForPersonalPickup, 'isDeliveryAvailableForPersonalPickup');
	component_subscribe($$self, isDeliveryAvailableForPersonalPickup, $$value => $$invalidate(3, $isDeliveryAvailableForPersonalPickup = $$value));
	let { $$slots: slots = {}, $$scope } = $$props;
	validate_slots('Order', slots, []);
	let { delivery } = $$props;
	let { paymentMethods } = $$props;

	$$self.$$.on_mount.push(function () {
		if (delivery === undefined && !('delivery' in $$props || $$self.$$.bound[$$self.$$.props['delivery']])) {
			console.warn("<Order> was created without expected prop 'delivery'");
		}

		if (paymentMethods === undefined && !('paymentMethods' in $$props || $$self.$$.bound[$$self.$$.props['paymentMethods']])) {
			console.warn("<Order> was created without expected prop 'paymentMethods'");
		}
	});

	const writable_props = ['delivery', 'paymentMethods'];

	Object.keys($$props).forEach(key => {
		if (!~writable_props.indexOf(key) && key.slice(0, 2) !== '$$' && key !== 'slot') console.warn(`<Order> was created with unknown prop '${key}'`);
	});

	const click_handler = () => orderStore.setProp('customer_type', 'PERSONAL');
	const click_handler_1 = () => orderStore.setProp('customer_type', 'COMPANY');

	const click_handler_2 = paymentMethod => {
		orderStore.setProp('payment_title', paymentMethod.title);
		orderStore.setProp('payment_method_type', paymentMethod.type);
		orderStore.setProp('price_payment', paymentMethod.price);
	};

	const change_handler = e => {
		orderStore.setProp('terms_and_conditions_consent', e.target.checked);
	};

	const change_handler_1 = e => {
		orderStore.setProp('sending_newsletters_consent', e.target.checked);
	};

	$$self.$$set = $$props => {
		if ('delivery' in $$props) $$invalidate(0, delivery = $$props.delivery);
		if ('paymentMethods' in $$props) $$invalidate(1, paymentMethods = $$props.paymentMethods);
	};

	$$self.$capture_state = () => ({
		OrderPersonal,
		OrderCompany,
		StandardDelivery,
		ZasilkovnaDelivery,
		orderStore,
		isDeliveryAvailableForPersonalPickup,
		delivery,
		paymentMethods,
		$orderStore,
		$isDeliveryAvailableForPersonalPickup
	});

	$$self.$inject_state = $$props => {
		if ('delivery' in $$props) $$invalidate(0, delivery = $$props.delivery);
		if ('paymentMethods' in $$props) $$invalidate(1, paymentMethods = $$props.paymentMethods);
	};

	if ($$props && "$$inject" in $$props) {
		$$self.$inject_state($$props.$$inject);
	}

	return [
		delivery,
		paymentMethods,
		$orderStore,
		$isDeliveryAvailableForPersonalPickup,
		click_handler,
		click_handler_1,
		click_handler_2,
		change_handler,
		change_handler_1
	];
}

class Order extends SvelteComponentDev {
	constructor(options) {
		super(options);
		init(this, options, instance, create_fragment, safe_not_equal, { delivery: 0, paymentMethods: 1 });

		dispatch_dev("SvelteRegisterComponent", {
			component: this,
			tagName: "Order",
			options,
			id: create_fragment.name
		});
	}

	get delivery() {
		throw new Error("<Order>: Props cannot be read directly from the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	set delivery(value) {
		throw new Error("<Order>: Props cannot be set directly on the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	get paymentMethods() {
		throw new Error("<Order>: Props cannot be read directly from the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	set paymentMethods(value) {
		throw new Error("<Order>: Props cannot be set directly on the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}
}

export default Order;